import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import Div from "@jumbo/shared/Div";
import LogoutIcon from '@mui/icons-material/Logout';
import { Chip, ListItemIcon, ListItemText, ThemeProvider, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { getProfileImage, getUserExName, getUserFullName } from 'app/utils/appHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { logoutUser, reset } from 'stores/auth';

const AuthUserDropdown = () => {
    const navigate = useNavigate();
    const dispact = useDispatch();
    const { theme } = useJumboTheme();


    const { authUser } = useSelector(state => state.auth);
    const onLogout = () => {
        // console.log('onLogout çalıştı', localStorage.getItem("user"))
        dispact(logoutUser());
        dispact(reset());

    };


    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={
                    (authUser && <Chip size="large" label={getUserExName(authUser).toLocaleUpperCase()} avatar={<Avatar src={getProfileImage(authUser.profileImageUrl)} alt={getUserFullName(authUser)} />} sx={{ cursor: 'pointer' }}></Chip>)
                }
            >
                <Div sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    p: theme => theme.spacing(2.5),
                }}>
                    {authUser && <Avatar src={getProfileImage(authUser.profileImageUrl)} alt={getUserFullName(authUser)} sx={{ width: 60, height: 60, mb: 2, textAlign: 'center' }} />}
                    {authUser && <Typography variant={"h4"}>{getUserFullName(authUser)}</Typography>}
                    {/* {authUser &&  <Typography variant={"body1"} color="text.secondary">{authUser.handle}</Typography>} */}
                </Div>
                <Divider />




                <nav>
                    <List disablePadding sx={{ pb: 1 }}>

                        <ListItemButton onClick={onLogout}>
                            <ListItemIcon sx={{ minWidth: 36 }}>
                                <LogoutIcon />
                            </ListItemIcon>
                            <ListItemText primary="Çıkış" sx={{ my: 0 }} />
                        </ListItemButton>
                    </List>
                </nav>
            </JumboDdPopover>
        </ThemeProvider>
    );
};

export default AuthUserDropdown;
